import { render, staticRenderFns } from "./GdDropdownItem.vue?vue&type=template&id=1b0ae432"
import script from "./GdDropdownItem.vue?vue&type=script&lang=js"
export * from "./GdDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports